<template>
  <StackPageLayout @close="handleClose">
    <template #title> Edit Product </template>
    <div
      class="flex min-h-full flex-col rounded-lg bg-background p-3"
    >
      <ProductForm
        :product-id="productId"
        @submit="handleSubmit"
      />
    </div>
  </StackPageLayout>
</template>

<script setup lang="ts">
import type { ProductFormOuput } from "@/forms/productForm"
import { updateProduct } from "@/services/products/updateProduct"

const props = defineProps<{ productId: string }>()

const { startLoading, stopLoading } =
  usePageBlockingLoading()

const router = useRouter()

const handleClose = () =>
  router.push({ name: "settingsProductIndex" })

const handleSubmit = async (params: ProductFormOuput) => {
  startLoading()
  try {
    await updateProduct(props.productId, {
      ...params,
      tagIds: [],
    })
    toast.success("Product updated")
    router.push({ name: "settingsProductIndex" })
  } catch {
    toast.error("Failed to update product")
  } finally {
    stopLoading()
  }
}
</script>
